/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  var $label = $(".acceptance");

  $label.append(
    '<span class="wpcf7-list-item-label"><a href="../policy" class="text-light-gray underline" target="_blank">個人情報の取り扱い</a> <span class="checkmark">に同意</span></span>'
  );
});
